import { useEffect, useState } from 'react';
import { Banner, Footer, Navbar } from '../components';
import { Button, Typography } from '@material-tailwind/react';
//@ts-ignore
import MSWord_Template from "../assets/docs/recpad2024_MSWord_Template.doc"
//@ts-ignore
import latex from "../assets/docs/recpad2024latex.zip"

const LIST = [
  "Biometrics",
  "Character recognition",
  "Classification clustering ensembles and multi-classifiers",
  "Data mining and big data",
  "Feature extraction, discretization and selection",
  "Fuzzy logic and fuzzy image processing",
  "Gesture recognition",
  "Hybrid methods",
  "Image description and registration",
  "Image enhancement, restoration and segmentation",
  "Image understanding",
  "Image fusion",
  "Information theory",
  "Intelligent systems",
  "Machine vision",
  "Neural network architectures",
  "Object recognition",
  "Pattern recognition applications",
  "Sensors and sensor fusion",
  "Soft computing techniques",
  "Statistical methods",
  "Syntactical methods",
  "Deep learning",
  "Transfer learning",
  "Natural language processing",
];

export function CallForPapers() {
  const [navbarTransparent, setNavbarTransparent] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = () => {
    window.open('https://cmt3.research.microsoft.com/RECPAD2024', '_blank');
  }
  

  return (
    <>
      <div className="w-full  relative">
        <Navbar transparent={navbarTransparent} />
        <Banner title={"Call for Papers"} subtitle={"(Deadline: September 06, 2024)"} />

        <section className="w-full container mx-auto px-0 lg:py-12 lg:px-14" >

          <div className="flex flex-col justify-center  w-full h-full p-8 text-lg">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              30th RECPAD - Portuguese Conference on Pattern Recognition
            </Typography>
            <Typography variant="paragraph" color="gray" className="font-normal mt-2">
              The Portuguese Conference on Pattern Recognition – RECPAD 2024 – is now inviting submissions reporting research and recent developments in Pattern Recognition by <strong>October 25, 2024, University of Beira Interior</strong>.
            </Typography>

            <Typography variant="paragraph" color="gray" className="font-normal mt-2">
              Authors are invited to submit two (2) pages of extended abstracts covering theoretical and/or applied work on pattern recognition via <strong>Microsoft CMT</strong>. All papers will be reviewed "single-blind", normally by two members of the Scientific Committee.
            </Typography>


            <div className="flex w-ful justify-center my-8" >
              <Button
                variant="filled"
                size="lg"
                className=" lg:inline-block bg-ubi-500  w-1/2"
                onClick={handleSubmit}
              >
                <span>Submit you paper</span>
              </Button>
            </div>

            <Typography variant="h3" color="blue-gray" className="mb-2 mt-8">
              Scope and Topics
            </Typography>

            <Typography color="gray" className="font-normal mt-2">
              RECPAD 2024 aims to promote collaboration between the Portuguese scientific community in the fields of Pattern Recognition, Image Analysis and Processing, Soft Computing, and related areas, including, but not limited to:
            </Typography>

            <ul className="mt-2 mb-4 list-disc lg:mb-0 lg:mt-4 pl-4">
              {LIST.map((item) => (

                <li className="font-normal text-sm text-gray-700">
                  {item}
                </li>
              ))}
            </ul>

            <Typography variant="h3" color="blue-gray" className="mb-2 mt-8">
              Publication and Presentation Types
            </Typography>

            <Typography color="gray" className="font-normal mt-2">
              The accepted papers will be compiled into the conference proceedings and distributed in electronic format. RECPAD 2024 constitutes a great opportunity for socializing and sharing experiences between young and senior researchers, showcasing their work, and looking ahead to the future.
            </Typography>

            <Typography variant="h3" color="blue-gray" className="mb-2 mt-8">
              Important dates
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              <ul className="mt-2 mb-4 list-disc lg:mb-0 lg:mt-4 pl-4">
                <li className="font-normal  text-gray-700">
                  <strong>September 6 </strong>- submission deadline
                </li>
                <li className="font-normal  text-gray-700">
                  <strong>October 8</strong> - notification
                </li>
                <li className="font-normal  text-gray-700">
                  <strong>October 17 </strong>- camera-ready deadline
                </li>
              </ul>
            </Typography>

            <Typography variant="h3" color="blue-gray" className="mb-2 mt-8">
              Instructions for Authors
            </Typography>

            <Typography color="gray" className="font-normal mt-2">
              Please be aware of the conference deadlines.
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              Abstracts must be written in English and submitted in PDF format via the <a className="underline text-blue-500" href="#" >Microsoft CMT</a>  platform.
            </Typography>
            <Typography color="gray" className="font-normal">
              They must not exceed the 2-page limit, which includes any and all results, figures, tables, and references.
            </Typography>
            <Typography color="gray" className="font-normal">
              Abstracts must also be formatted according to the RECPAD templates:
            </Typography>
            <Typography color="blue" className="font-normal underline">
              <a href={MSWord_Template} download >MS Word Template</a>
            </Typography>
            <Typography color="blue" className="font-normal underline">
              <a href={latex} download >LaTeX Template</a>
            </Typography>

            <Typography color="gray" className="font-normal mt-8">
              Abstracts that fail to meet any of the above requirements will not be reviewed.
            </Typography>
            <Typography color="gray" className="font-normal mt-2">
              The work presented in the abstract does not need to be novel, but proper citations must be included.
            </Typography>

          </div>

        </section>
        <Footer />

      </div>
    </>
  );
}
